module.exports = __webpack_public_path__ + "img/txxx.55e95290.png";